// extracted by mini-css-extract-plugin
export var addButton = "_n9-0";
export var border = "_n9-8";
export var check = "_n9-h";
export var danger = "_n9-6";
export var dropdownContainer = "_n9-1";
export var editModalBody = "_n9-j";
export var footerContainer = "_n9-i";
export var fullWidth = "_n9-a";
export var hide = "_n9-9";
export var icon = "_n9-3";
export var input = "_n9-7";
export var inputFlex = "_n9-b";
export var inputWrapper = "_n9-c";
export var manualFocus = "_n9-5";
export var optionButton = "_n9-4";
export var pillWrapper = "_n9-e";
export var pointer = "_n9-2";
export var showOverflow = "_n9-f";
export var tagsFlex = "_n9-d";
export var xButton = "_n9-g";